import { IReportingCategory } from '@/interfaces/IReportingCategory';

/** The picker value of «Igual que su categoría» (no own reporting category). */
export const INHERIT_REPORTING_VALUE = 'inherit';

export interface IReportingOption {
  value: string;
  label: string;
}

/**
 * The reporting categories a product or category can use: the leaves
 * («Bebidas › Vinos»), since a parent with children is ambiguous.
 */
export function reportingLeafOptions(
  all: readonly IReportingCategory[],
  locale?: string
): IReportingOption[] {
  const byId = new Map(all.map((row) => [row.id, row]));
  return all
    .filter((row) => !all.some((other) => other.parentId === row.id))
    .map((row) => {
      const parent = row.parentId !== null ? byId.get(row.parentId) : null;
      return {
        value: String(row.id),
        label: parent ? `${parent.name} › ${row.name}` : row.name,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label, locale));
}

export function reportingValue(id: number | null): string {
  return id === null ? INHERIT_REPORTING_VALUE : String(id);
}

export function reportingIdFromValue(value: string): number | null {
  if (value === INHERIT_REPORTING_VALUE) return null;
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
}
